import api from '../instance'

export function fetchLegalPersons(centerCostCode) {
  return api.get(`/legalPerson?costCenterCode=${centerCostCode}`)
}
